import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pageDirector/pageDirector_function.svg'
import _imports_1 from '@/assets/pageDirector/pageDirector_function_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-68a3267a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pc_worp" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "pc_worp_nav" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "pc_worp_nav_bg" }
const _hoisted_6 = { class: "nav_left" }
const _hoisted_7 = { class: "nav_bg_box" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "worp_txt" }
const _hoisted_10 = { class: "nav_right" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav_bg_box right_img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://images.innocomn.com/avatar.png" })
], -1))
const _hoisted_12 = { class: "worp_txt name_color" }
const _hoisted_13 = {
  key: 0,
  class: "worp_txt right_btn"
}
const _hoisted_14 = { class: "pc_worp_content" }
const _hoisted_15 = { class: "content_box" }
const _hoisted_16 = { class: "content_left" }
const _hoisted_17 = { class: "left_cover" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "content_right" }
const _hoisted_20 = { class: "right_title" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right_title_btn worp_txt" }, "聊天互动", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right_title_btn worp_txt" }, "在线观众", -1))
const _hoisted_24 = { class: "right_con" }
const _hoisted_25 = { class: "right_work" }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"msg_item\" data-v-68a3267a><div class=\"msg_avatar\" data-v-68a3267a><img src=\"https://images.innocomn.com/avatar.png\" data-v-68a3267a></div><div class=\"msg_content\" data-v-68a3267a><div class=\"worp_txt name_color\" data-v-68a3267a>上海市网友</div><div class=\"mef_txt worp_txt\" data-v-68a3267a>聊天记录聊天记录</div></div></div>", 1)
const _hoisted_28 = { class: "right_work_btn" }
const _hoisted_29 = {
  key: 0,
  src: _imports_0,
  class: "work_btn_fun"
}
const _hoisted_30 = {
  key: 1,
  src: _imports_1,
  class: "work_btn_fun"
}
const _hoisted_31 = { class: "right_bottom" }
const _hoisted_32 = { class: "send_box" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "send_in" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "worp_txt send_txt" }, "这里输入..."),
  /*#__PURE__*/_createElementVNode("div", { class: "send_in_r" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "worp_txt send_in_r_btn",
      size: "small"
    }, "发送")
  ])
], -1))
const _hoisted_34 = { class: "send_icon" }
const _hoisted_35 = { class: "content_cusmenu worp_txt" }
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content_cusmenu_txt" }, "图文内容 >", -1))

import { ref, unref, watch, computed, watchEffect } from 'vue';
import { CaretDownOutlined, ClockCircleOutlined } from '@ant-design/icons-vue';
import { ModalData } from './type';
import { useLiveStore } from '@/pinia/live';
import { useStore } from 'vuex';
interface IProps {
  modelValue: ModalData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewPc',
  props: {
    modelValue: null
  },
  setup(__props: any) {

const props = __props as {
  modelValue: ModalData;
};

_useCssVars(_ctx => ({
  "60a51479": (form.value.pcBgColor),
  "46dc96ae": (form.value.textColor2),
  "ee5c5c46": (form.value.titleColor),
  "46dc96ad": (form.value.textColor1),
  "9ff91440": (form.value.topBbColor),
  "00fc7bec": (form.value.opacity_pc_0),
  "2305aa8a": (form.value.tabBgColor),
  "00fc7bea": (form.value.opacity_pc_1),
  "1341fd0c": (form.value.themeColor),
  "7ae8c3a4": (form.value.tabTitleColor),
  "969e7d62": (form.value.msgBgColor),
  "00fc7be8": (form.value.opacity_pc_2),
  "9c1e1a58": (form.value.msgColor),
  "625e555e": (form.value.pc_botton_bg),
  "724395c4": (form.value.sendBgColor),
  "00af3eee": (form.value.sendColor),
  "4a493fe6": (form.value.menuBgColor),
  "00fc7be6": (form.value.opacity_pc_3),
  "e7b4f0f6": (iconStyle.value.like),
  "e7b97dc4": (iconStyle.value.gift),
  "e7b3d97a": (iconStyle.value.more)
}))

const liveInfo = computed(() => useLiveStore().liveInfo);
const userData = computed(() => useStore().state.user.userInfo);

const form = ref<ModalData>({
  topShow: false,
  logoUrl: ' ',
  videoCv: '',
  themeColor: '',
  pcBgColor: '',
  pcBgUrl: '',
  textColor1: ' ',
  textColor2: ' ',
  tabBgColor: '',
  pc_botton_bg: '',
  msgBgColor: '',
  sendBgColor: '',
  menuBgColor: '',
  topBbColor: '',
  msgColor: '',
  tabTitleColor: '',
  titleColor: '',
  sendColor: '',
  type: '0',
  mobile_bg: '',
  mobile_meau_bg: '',
  mobile_meau_color: '',
  mobile_send_bg: '',
  mobile_botton_bg: '',
});

form.value = unref(props.modelValue);
watch(
  () => props.modelValue,
  () => {
    form.value = unref(props.modelValue);
    init();
  }
);
const iconStyle = ref({
  like: '',
  gift: '',
  more: '',
});

const init = () => {
  switch (props.modelValue.type) {
    case '1':
      iconStyle.value.like = '#41474c';
      iconStyle.value.gift = '#394551';
      iconStyle.value.more = '#394551';
      form.value.pc_botton_bg = '#232F3B';
      form.value.titleColor = '#E2E8F0';
      form.value.textColor1 = '#A4B3CA';
      form.value.textColor2 = '#A4B3CA';
      form.value.tabTitleColor = '#FFFFFF';
      form.value.sendBgColor = '#394551';
      break;
    case '2':
      iconStyle.value.like = '#dec58d47';
      iconStyle.value.gift = '#ffe1e9';
      iconStyle.value.more = '#def5f2';
      form.value.pc_botton_bg = '#D82737';
      form.value.titleColor = '#FFFFFF';
      form.value.textColor1 = '#FFFFFF';
      form.value.textColor2 = '#FFFFFF';
      form.value.tabTitleColor = '#ED9D67';
      form.value.sendBgColor = '#D0514C';
      break;
    case '3':
      iconStyle.value.like = '#aaffe636';
      iconStyle.value.gift = '#00000000';
      iconStyle.value.more = '#00000000';
      form.value.pc_botton_bg = '#0A486C';
      form.value.titleColor = '#FFFFFF';
      form.value.textColor1 = '#FFFFFF';
      form.value.textColor2 = '#FFFFFF';
      form.value.tabTitleColor = '#FFFFFF';
      form.value.sendBgColor = '#013357';
      break;
      case '4':
      form.value.titleColor = '#FBD793';
      form.value.textColor1 = '#FBD793';
      form.value.textColor2 = '#FFFFFF';
      form.value.tabTitleColor = '#FFFFFF';
      form.value.pc_botton_bg = '#162231';
      form.value.sendBgColor = '#0A1626';
      break;
    default:
      iconStyle.value.like = '#fff4e3';
      iconStyle.value.gift = '#ffe4ea';
      iconStyle.value.more = '#e8fffc';
      form.value.pc_botton_bg = '#FFFFFF';
      form.value.titleColor = '#333333';
      form.value.textColor1 = '#505D6F';
      form.value.textColor2 = '#333333';
      form.value.tabTitleColor = '#505D6F';
      form.value.sendBgColor = '#F2F4F8';
      break;
  }
};
init();

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (form.value.pcBgUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: form.value.pcBgUrl,
          class: "pc_worp_bg"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (form.value.pc_top_bgimg)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: form.value.pc_top_bgimg,
            class: "pc_worp_nav_img"
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (form.value.logoUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: form.value.logoUrl
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, _toDisplayString(_unref(liveInfo).title), 1),
            _createElementVNode("p", null, [
              _createVNode(_component_svg_icon, { "icon-class": "pageDirector_time" }),
              _createTextVNode("  " + _toDisplayString(_unref(liveInfo).start_at) + "   ", 1),
              _createVNode(_component_svg_icon, { "icon-class": "pageDirector_mobile" }),
              _createTextVNode("  手机观看 ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createTextVNode("上海市网友 "),
            _createVNode(_unref(CaretDownOutlined))
          ]),
          (form.value.topShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "免费试用 · "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (form.value.videoCv)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: form.value.videoCv
                }, null, 8, _hoisted_18))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (form.value.pc_tab_bgimg)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: form.value.pc_tab_bgimg,
                  class: "right_title_img"
                }, null, 8, _hoisted_21))
              : _createCommentVNode("", true),
            _hoisted_22,
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              (form.value.pc_msg_bgimg)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "right_work_bg",
                    src: form.value.pc_msg_bgimg
                  }, null, 8, _hoisted_26))
                : _createCommentVNode("", true),
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                (props.modelValue.type === '0')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                  : (_openBlock(), _createElementBlock("img", _hoisted_30)),
                _createVNode(_component_svg_icon, {
                  "icon-class": "pageDirector_like",
                  class: "btn_like"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "pageDirector_gift",
                    class: "btn_gift"
                  }),
                  _createVNode(_component_svg_icon, {
                    "icon-class": "pageDirector_more",
                    class: "btn_more"
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        (form.value.pc_meau_bgimg)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: form.value.pc_meau_bgimg,
              class: "content_cusmenu_img"
            }, null, 8, _hoisted_36))
          : _createCommentVNode("", true),
        _hoisted_37
      ])
    ])
  ]))
}
}

})